import { themes } from "../ExpTheme/options/initThemes";
import layout1Settings from "./Layout1/Layout1Settings";

// UPDATE BELOW CODE
// DOC http://demos.ui-lib.com/Exp-react-doc/layout.html
export const ExpLayoutSettings = {
	activeLayout: "layout1", // layout1, layout2
	activeTheme: "blue", // View all valid theme colors inside ExpTheme/themeColors.js
	perfectScrollbar: false,
	logo: "/assets/images/logo.png",	// bhhan

	themes: themes,
	layout1Settings, // open Layout1/Layout1Settings.js
	//layout2Settings, // open Layout1/Layout2Settings.js

	secondarySidebar: {
		show: true,
		open: false,
		theme: "slateDark1" // View all valid theme colors inside ExpTheme/themeColors.js
	},
	// Footer options
	footer: {
		show: true,
		fixed: false,
		theme: "slateDark1" // View all valid theme colors inside ExpTheme/themeColors.js
	}
};
